import React, { useState, useEffect } from "react";
import Video from "./Video";

function Section(props) {
  const { sectionId } = props;
  const [collapse, setCollapse] = useState(
    props.show ? "collapse show" : "collapse"
  );

  useEffect(() => {
    setCollapse(props.show ? "collapse show" : "collapse");
  }, [props.show]);

  return (
    <div className="card nav-item">
      <button
        className="btn-section card-header "
        type="button"
        data-toggle="collapse"
        data-target={`#section${sectionId}`}
        aria-expanded={collapse === "collapse show" ? true : false}
        aria-controls={`section${sectionId}`}
        onClick={() =>
          collapse === "collapse"
            ? setCollapse("collapse show")
            : setCollapse("collapse")
        }
      >
        <h2 id={`heading${sectionId}`}>
          {props.section.name}
          {collapse === "collapse" ? (
            <span className="toggle-section">
              <i className="fas fa-chevron-down" />
            </span>
          ) : (
            <span className="toggle-section">
              <i className="fas fa-chevron-up" />
            </span>
          )}
        </h2>
      </button>

      <div
        id={`section${sectionId}`}
        className={collapse}
        aria-labelledby={`heading${sectionId}`}
        data-parent="#accordionContent"
      >
        <div className="list-group list-group-flush">
          {props.section.videos.map(video => {
            return (
              <Video
                handleVideoSelect={props.handleVideoSelect}
                video={video}
                current={props.current}
                key={video.id}
                sections={props.sections}
              />
            );
          })}
        </div>
      </div>
    </div>
  );
}

export default Section;
